import RicePreviewRender from './src/RicePreviewRender.vue';

RicePreviewRender.install = function ( Vue ) {
    Vue.component(RicePreviewRender.name,RicePreviewRender);
}

export default RicePreviewRender;


//////////////////
// WEBPACK FOOTER
// ./packages/RicePreviewRender/index.js
// module id = null
// module chunks = 